<template>
  <div class="container">
    <div class="title">售后申请</div>
    <el-form
        class="form-inline"
        :model="formData"
        ref="afterSalesForm"
        label-width="80px"
    >
      <!-- 球杆编号 -->
      <el-form-item label="球杆编号：" prop="number">
        <el-input
            v-model="formData.number"
            placeholder="请选择球杆编号"
            @keydown.prevent
            @click.native="openSelectDialog()"
            readonly
        ></el-input>
      </el-form-item>

      <!-- 原因说明 -->
      <el-form-item label="原因说明：" prop="checkType" class="reason-item">
        <el-radio-group v-model="formData.checkType"  class="reason-radio-group">
          <el-radio
              v-for="item in reasonOptions"
              :key="item.value"
              :label="item.value"
              class="reason-radio"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
        <el-input
            type="textarea"
            v-model="formData.description"
            placeholder="请输入问题描述（选填）"
            rows="3"
            class="reason-textarea"
        ></el-input>
      </el-form-item>

      <el-form-item label="上传图片：" prop="images">
        <el-upload
            class="avatar-uploader"
            action="#"
            accept="image/*"
            :capture="captureType"
            :on-change="handleFileChange"
            :file-list="fileList"
            list-type="picture-card"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :limit="3"
            :on-exceed="handleExceed"
            multiple
            :auto-upload="false"
        >
        <i class="el-icon-plus" />
        </el-upload>
        <div class="upload-tip">最多上传3张图片，支持jpg/png格式，可多选</div>
        <!-- 图片预览弹窗 -->
        <el-dialog :visible.sync="dialogVisible" title="图片预览" width="90%" append-to-body>
          <img
              :src="dialogImageUrl"
              alt="预览图"
              style="width: 100%; max-height: 80vh; object-fit: contain;"
              @error="handleImageError"
          />
          <div v-if="!dialogImageUrl" class="preview-empty">暂无预览图片</div>
        </el-dialog>
      </el-form-item>
      <!-- 姓名 -->
      <el-form-item label="姓名：" prop="userName">
        <el-input
            v-model="formData.userName"
            placeholder="请输入您的姓名"
            clearable
        ></el-input>
      </el-form-item>

      <!-- 电话 -->
      <el-form-item label="电话：" prop="telephone">
        <el-input
            v-model="formData.telephone"
            placeholder="请输入您的电话"
            type="tel"
            clearable
        ></el-input>
      </el-form-item>

      <!-- 地址（省/市联动） -->
      <el-form-item label="地址：" prop="address">
        <el-row :gutter="10">
          <el-col :span="11">
            <el-select
                v-model="formData.province"
                @change="updateCityList"
                placeholder="选择省份"
                clearable
                filterable
                class="addr-select"
                :popper-append-to-body="false"
            >
              <el-option
                  v-for="(item, index) in provinces"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="11">
            <el-select
                v-model="formData.city"
                placeholder="选择城市"
                clearable
                filterable
                :disabled="!formData.province"
                class="addr-select"
                :popper-append-to-body="false"
            >
              <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item"
                  :value="item"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 详细地址 -->
      <el-form-item label="详细地址：" prop="detailAddr">
        <el-input
            v-model="formData.detailAddr"
            placeholder="请输入您详细地址"
            clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="btn-group">
      <el-button type="primary" @click="submitForm">提交申请</el-button>
    </div>
    <div class="btn-group-back">
      <el-button type="default" @click="goHome">返回首页</el-button>
    </div>
    <el-footer class="s-footer">
      <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
    </el-footer>
    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        title="提示"
        :content="messageContent"
        confirmText="我知道了"
        :showCancel="false"
        @confirm="showDialog = false"
        @close="showDialog = false"
        closeOnMask
    />

    <!-- 引入自定义select组件 -->
    <SelectDialog
        :visible="selectDialogVisible"
        :options="selectOptions"
        :active-value="formData.number"
        @select="handleSelect"
        @close="selectDialogVisible = false"
    />
  </div>
</template>

<script>
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import {afterPost, productByUser} from "@/api/sales";
import SelectDialog from "@/views/business/utils/selectDialog.vue";
import {PROVINCE_DATA} from "@/enums/provinceCityEnum";



export default {
  name: "AfterSalesApply",
  components: {SelectDialog, MessageDialog},
  data() {

    return {
      //select弹框组件
      selectDialogVisible: false,

      selectOptions: [],

      // 问题原因选项
      reasonOptions: [
        { label: "保养维护", value: "保养维护" },
        { label: "木头开裂", value: "木头开裂" },
        { label: "铜头松动", value: "铜头松动" },
        { label: "球杆调直", value: "球杆调直" },
        { label: "其它原因", value: "其它原因" },
      ],
      // 省市区相关
      provinces: PROVINCE_DATA,
      cityList: [],
      // 图片上传相关
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      captureType: "",

      showDialog: false,
      messageContent: "",
      // 表单数据
      formData: {
        number: "",
        checkType: [],
        description: "",
        userName: "",
        telephone: "",
        province: "",
        city: "",
        detailAddr: "",
      },
    };
  },
  methods: {

    //获取当前登录人名下注册登记的球杆
    openSelectDialog(){
      productByUser().then(res => {
        if (res.code === 200) {
          this.selectOptions = res.data;
          this.selectDialogVisible = true; // 打开弹框
        } else {
          this.showDialog = true;
          this.messageContent = res.returnMsg;
        }
      })
    },

    //获取当前登录人名下注册登记的球杆
    handleSelect(item) {
      this.formData.number = item.value; // 赋值到对应行
      this.selectDialogVisible = false; // 关闭弹框
      this.selectOptions = [];
    },

    // 返回首页
    goHome() {
      this.$router.replace("/sales_home");
    },

    handleFileChange(file, fileList) {
      // 1. 仅处理「文件添加」的场景（status=ready）
      if (file.status !== 'ready') {
        return; // 忽略移除/上传中的状态
      }

      // 2. 校验文件类型（和原before-upload逻辑一致）
      const isImage = file.raw.type.includes("image/"); // 注意：file.raw才是原生File对象
      if (!isImage) {
        this.$message.error("只能上传jpg/png格式的图片！");
        // 移除错误文件（避免加入fileList）
        this.fileList = fileList.filter(item => item.uid !== file.uid);
        return;
      }

      // 3. 生成预览URL并更新fileList（和原逻辑一致）
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        // 4. 确保fileList同步为最新列表（Element UI返回的fileList是最新的）
        this.fileList = fileList.map(item => {
          // 给当前添加的文件补充预览URL
          if (item.uid === file.uid) {
            return {
              ...item,
              url: e.target.result, // 预览URL
              raw: file.raw         // 保存原生File对象（提交时用）
            };
          }
          return item;
        });
      };
    },


    // 核心修复4：预览方法重构，确保URL和弹框状态正确
    handlePreview(file) {
      console.log("预览文件信息：", file); // 调试用，可保留
      // 优先级：本地预览URL > 响应URL > 原始文件
      if (file.url) {
        this.dialogImageUrl = file.url;
      } else if (file.raw) {
        // 兼容未生成URL的情况，重新生成
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (e) => {
          this.dialogImageUrl = e.target.result;
        };
      } else {
        this.dialogImageUrl = "";
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //提示信息内容
        this.messageContent = "该图片无预览地址！";
      }
      // 强制打开弹框（确保状态更新）
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },

    // 核心修复5：图片加载失败处理
    handleImageError() {
      this.dialogImageUrl = "";
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //提示信息内容
      this.messageContent = "图片预览失败，请重新上传！";
    },

    // 删除文件（确保列表同步）
    handleRemove(file, fileList) {
      this.fileList = [...fileList]; // 深拷贝，避免引用问题
    },

    // 超出数量提示
    handleExceed() {
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //提示信息内容
      this.messageContent = `最多只能上传3张图片！`;
    },

    // 更新城市列表
    updateCityList() {
      const targetProvince = this.provinces.find((item) => item.name === this.formData.province);
      this.cityList = targetProvince ? targetProvince.cities : [];
      // 清空已选城市（省份切换后重置）
      this.formData.city = "";
    },

    //表单校验
    beforeSubmitValid(){
      let number = this.formData.number;
      let userName = this.formData.userName;
      let telephone = this.formData.telephone;

      let province = this.formData.province;
      let city = this.formData.city;

      if(number === ''){
        this.showDialog = true;
        this.messageContent = `请输入球杆编号`;
        return false;
      } else if(userName === ''){
        this.showDialog = true;
        this.messageContent = `请输入您的姓名`;
        return false;
      } else if(province === ''){
        this.showDialog = true;
        this.messageContent = `请选择您所在的省份/直辖市`;
        return false;
      } else if(city === ''){
        this.showDialog = true;
        this.messageContent = `请选择您所在的城市`;
        return false;
      } else if(telephone === ''){
        this.showDialog = true;
        this.messageContent = `请输入您的电话号码`;
        return false;
      } else if(telephone){
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(telephone)) {
          this.showDialog = true;
          this.messageContent = `请输入正确的电话号码`;
          return false;
        }
      }
      return true;
    },



    // 提交表单
    submitForm() {

      const flag = this.beforeSubmitValid();
      if(flag) {
        const formData = new FormData();

        formData.append('number', this.formData.number);
        formData.append('checkType', this.formData.checkType); // 单选值，直接传
        formData.append('description', this.formData.description);
        formData.append('userName', this.formData.userName);
        formData.append('telephone', this.formData.telephone);
        formData.append('address', this.formData.province+this.formData.city+this.formData.detailAddr);

        const files = [];
        this.fileList.forEach(item => {
          if (item.raw) {
            files.push(item.raw);
            formData.append('rImg', item.raw);
          }
        });


        afterPost(formData).then(res => {
          if(res.code==200){
            const data = res.data;
            if (data.code == 1) {

              this.showDialog = true;
              this.messageContent = data.returnMsg;

              // var keyword = data.keyword;
              //
              // window.open('http://www.jingdian147.com/portals/sales/getStep?keyword='+keyword);

            }else if(data.code ==0) {
              this.showDialog = true;
              this.messageContent = data.returnMsg;
            }else if(data.code ==2){
              this.showDialog = true;
              this.messageContent = data.returnMsg;
              // var keyword = data.keyword;
              // var urlType = data.urlType;
              // //提交售后没有 登记
              // window.open('http://www.jingdian147.com/portals/sales/register?keyword='+keyword+'&urlType='+urlType);
            }else if(data.code ==3){
              this.showDialog = true;
              this.messageContent = data.returnMsg;
            }else if(data.code ==4){
              this.showDialog = true;
              this.messageContent = data.returnMsg;
              // var keyword = data.keyword;
              // window.open('http://www.jingdian147.com/portals/sales/getStep?keyword='+keyword);
            } else if(res.data.code ==0){
              this.showDialog = true;
              this.messageContent = data.returnMsg;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">

.container {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #efefef;

  @media screen and (max-width: 768px) {
    /* -------------------------- 1. 复选框样式 -------------------------- */
    .el-checkbox {
      font-size: 14px;
    }
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 2px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      width: 8px;
      height: 14px;
      top: -5px;
    }
    .el-checkbox__label {
      margin: 0 auto;
      font-size: 10px;
    }

    /* -------------------------- 2. 下拉选择框（核心修复） -------------------------- */
    .addr-select {
      width: 100%;
      // 输入框基础样式（保留原有）
      .el-input__suffix {
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
      .el-input__icon {
        width: 16px !important;
        height: 16px !important;
        font-size: 14px !important;
        line-height: 16px !important;
        vertical-align: middle;
        margin-left: 5px;
      }
      .el-input__inner {
        padding-right: 25px !important;
        font-size: 16px !important;
        height: 50px !important;
        line-height: 50px !important;
        border: none;
        border-radius: 4px;
        background: #f9f9f9;
        padding-left: 10px;
      }

      // 1. 下拉面板整体样式
      .el-select-dropdown {
        width: 100% !important; // 适配容器宽度
        margin-top: 5px !important;
        border: none !important;
        border-radius: 6px !important;
        box-shadow: 0 2px 12px rgba(0,0,0,0.1) !important; // 柔和阴影
        background: #fff !important;
        padding: 5px 0 !important; // 上下内边距
      }

      // 2. 下拉选项样式
      .el-select-dropdown__item {
        height: 20px !important; // 适配移动端点击区域
        line-height: 20px !important;
        font-size: 15px !important; // 字体大小适配
        padding: 0 15px !important; // 左右内边距
        color: #333 !important;
        transition: all 0.2s ease; // 过渡动画
        // 选项hover样式
        &:hover {
          background: #f8e8d1 !important; // 主色调浅背景
          color: #0f0f0f !important;
        }
        // 选中项样式
        &.selected {
          color: #0f0f0f !important;
          font-weight: 500;
          background: #f6c27a !important; // 主色调背景
        }
        // 禁用项样式
        &.is-disabled {
          color: #ccc !important;
          background: #fafafa !important;
        }
      }

      // 3. 搜索框样式（filterable）
      .el-select-dropdown__empty,
      .el-select__input {
        font-size: 15px !important;
        padding: 0 10px !important;
        height: 45px !important;
        line-height: 45px !important;
      }

      // 4. 下拉面板空状态
      .el-select-dropdown__empty {
        text-align: center;
        padding: 15px;
        color: #999;
        font-size: 14px;
      }

      // 5. 禁用状态下的输入框样式
      &.is-disabled {
        .el-input__inner {
          background: #f5f5f5 !important;
          color: #999 !important;
          cursor: not-allowed;
        }
      }
    }

    /* ------------------------ 3. 图片上传 ---------------------------- */
    .el-upload--picture-card {
      height: 50px;
      line-height: 50px;
    }

    /* ------------------------- 4. 底部按钮 --------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 20px 0;
    }
    .el-button--primary {
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }
    .el-button--default {
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* ------------------------- 5. 文本框 --------------------------- */
    .form-inline {
      padding: 5px 0;
    }
    .el-form-item {
      background: #ffffff;
      height: auto; // 修复原固定高度导致的内容溢出
      padding: 0 10px;
      margin-bottom: 5px; // 增加表单项间距
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content {
      line-height: 50px;
      padding-left: 30px;
      .el-checkbox {
        line-height: 30px;
      }
    }
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;
      height: 50px !important;
      line-height: 50px !important;
      border: none;
    }
    .el-textarea {
      vertical-align: top;
    }


    /* -------------------------- 仅增加 Label 宽度 -------------------------- */
    .el-form {
      // 覆盖Element默认Label宽度，与模板中 label-width 保持一致
      --el-form-label-width: 90px !important;
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
      white-space: nowrap !important; // 保留强制不换行（配合宽度增加）
      flex: 0 0 100px !important; // 固定宽度与 label-width 一致
      max-width: 90px !important; // 最大宽度同步
    }

    /* 核心修改：单选框样式适配 */
    .reason-radio-group {
      display: flex;
      flex-wrap: wrap; // 选项过多时自动换行
      gap: 10px 15px; // 选项间距（上下/左右）
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .reason-radio {
      font-size: 14px !important;
      .el-radio__inner {
        width: 14px;
        height: 14px; // 单选按钮大小
      }
      .el-radio__label {
        font-size: 12px !important;
        margin-left: 5px; // 按钮与文字间距
      }
    }

    /* -------------------------- 核心修改：统一预览/删除按钮样式 -------------------------- */
    // 上传卡片/缩略图基础样式
    .avatar-uploader {
      .el-upload--picture-card {
        width: 100px !important;
        height: 100px !important;
        line-height: 100px !important;
        font-size: 20px !important;
      }
    }
    .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        position: relative; // 确保子元素绝对定位生效
      }
      // 已上传图片预览图适配
      .el-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      // 1. 删除按钮样式（基准）
      .el-upload-list__item-delete {
        font-size: 16px !important; // 按钮大小
        top: 5px !important;        // 垂直位置
        right: 5px !important;      // 水平位置
        width: 20px !important;     // 点击区域大小
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景（可选，和预览按钮统一）
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
      }

      // 2. 预览按钮样式（和删除按钮完全统一）
      .el-upload-list__item-preview {
        font-size: 16px !important; // 和删除按钮同大小
        top: 5px !important;        // 和删除按钮同垂直位置
        right: 30px !important;     // 位于删除按钮左侧，间距合理
        width: 20px !important;     // 点击区域和删除按钮一致
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景，和删除按钮统一
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
        // 预览图标居中
        .el-icon-zoom-in {
          font-size: 14px !important; // 图标略小于按钮，视觉更协调
          line-height: 20px !important;
        }
      }

      // 鼠标悬浮效果（可选，增强交互）
      .el-upload-list__item:hover .el-upload-list__item-delete,
      .el-upload-list__item:hover .el-upload-list__item-preview {
        background: rgba(0,0,0,0.7);
      }
    }

    // 预览弹框空状态样式
    .preview-empty {
      text-align: center;
      padding: 20px;
      color: #999;
      font-size: 14px;
    }



    /* ------------------------- 6. 其他样式 --------------------------- */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }
    .reason-item {
      height: auto !important; // 修复原因说明项固定高度问题
      padding-bottom: 10px;
    }
    .reason-textarea {
      margin-top: 10px;
      width: 100%;
    }
    .upload-tip {
      font-size: 10px;
      color: #999;
      margin-top: 5px;
    }
    .s-footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }

  // ===================== 平板适配（768px ≤ 宽度 < 1200px） =====================
  @media screen and (min-width: 768px) and (max-width: 1199px) {
    max-width: 900px; // 平板最大宽度
    margin: 0 auto; // 居中
    padding: 0 20px;
    /* -------------------------- 1. 复选框样式 -------------------------- */
    .el-checkbox {
      font-size: 14px;
    }
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 2px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      width: 8px;
      height: 14px;
      top: -5px;
    }
    .el-checkbox__label {
      margin: 0 auto;
      font-size: 10px;
    }

    /* -------------------------- 2. 下拉选择框（核心修复） -------------------------- */
    .addr-select {
      width: 100%;
      // 输入框基础样式（保留原有）
      .el-input__suffix {
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
      .el-input__icon {
        width: 16px !important;
        height: 16px !important;
        font-size: 14px !important;
        line-height: 16px !important;
        vertical-align: middle;
        margin-left: 5px;
      }
      .el-input__inner {
        padding-right: 25px !important;
        font-size: 16px !important;
        height: 50px !important;
        line-height: 50px !important;
        border: none;
        border-radius: 4px;
        background: #f9f9f9;
        padding-left: 10px;
      }

      // 1. 下拉面板整体样式
      .el-select-dropdown {
        width: 100% !important; // 适配容器宽度
        margin-top: 5px !important;
        border: none !important;
        border-radius: 6px !important;
        box-shadow: 0 2px 12px rgba(0,0,0,0.1) !important; // 柔和阴影
        background: #fff !important;
        padding: 5px 0 !important; // 上下内边距
      }

      // 2. 下拉选项样式
      .el-select-dropdown__item {
        height: 20px !important; // 适配移动端点击区域
        line-height: 20px !important;
        font-size: 15px !important; // 字体大小适配
        padding: 0 15px !important; // 左右内边距
        color: #333 !important;
        transition: all 0.2s ease; // 过渡动画
        // 选项hover样式
        &:hover {
          background: #f8e8d1 !important; // 主色调浅背景
          color: #0f0f0f !important;
        }
        // 选中项样式
        &.selected {
          color: #0f0f0f !important;
          font-weight: 500;
          background: #f6c27a !important; // 主色调背景
        }
        // 禁用项样式
        &.is-disabled {
          color: #ccc !important;
          background: #fafafa !important;
        }
      }

      // 3. 搜索框样式（filterable）
      .el-select-dropdown__empty,
      .el-select__input {
        font-size: 15px !important;
        padding: 0 10px !important;
        height: 45px !important;
        line-height: 45px !important;
      }

      // 4. 下拉面板空状态
      .el-select-dropdown__empty {
        text-align: center;
        padding: 15px;
        color: #999;
        font-size: 14px;
      }

      // 5. 禁用状态下的输入框样式
      &.is-disabled {
        .el-input__inner {
          background: #f5f5f5 !important;
          color: #999 !important;
          cursor: not-allowed;
        }
      }
    }

    /* ------------------------ 3. 图片上传 ---------------------------- */
    .el-upload--picture-card {
      height: 50px;
      line-height: 50px;
    }

    /* ------------------------- 4. 底部按钮 --------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 20px 0;
    }
    .el-button--primary {
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }
    .el-button--default {
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* ------------------------- 5. 文本框 --------------------------- */
    .form-inline {
      padding: 5px 0;
    }
    .el-form-item {
      background: #ffffff;
      height: auto; // 修复原固定高度导致的内容溢出
      padding: 0 10px;
      margin-bottom: 5px; // 增加表单项间距
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content {
      line-height: 50px;
      padding-left: 30px;
      .el-checkbox {
        line-height: 30px;
      }
    }
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;
      height: 50px !important;
      line-height: 50px !important;
      border: none;
    }
    .el-textarea {
      vertical-align: top;
    }


    /* -------------------------- 仅增加 Label 宽度 -------------------------- */
    .el-form {
      // 覆盖Element默认Label宽度，与模板中 label-width 保持一致
      --el-form-label-width: 90px !important;
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
      white-space: nowrap !important; // 保留强制不换行（配合宽度增加）
      flex: 0 0 100px !important; // 固定宽度与 label-width 一致
      max-width: 90px !important; // 最大宽度同步
    }

    /* 核心修改：单选框样式适配 */
    .reason-radio-group {
      display: flex;
      flex-wrap: wrap; // 选项过多时自动换行
      gap: 10px 15px; // 选项间距（上下/左右）
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .reason-radio {
      font-size: 14px !important;
      .el-radio__inner {
        width: 14px;
        height: 14px; // 单选按钮大小
      }
      .el-radio__label {
        font-size: 12px !important;
        margin-left: 5px; // 按钮与文字间距
      }
    }

    /* -------------------------- 核心修改：统一预览/删除按钮样式 -------------------------- */
    // 上传卡片/缩略图基础样式
    .avatar-uploader {
      .el-upload--picture-card {
        width: 100px !important;
        height: 100px !important;
        line-height: 100px !important;
        font-size: 20px !important;
      }
    }
    .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        position: relative; // 确保子元素绝对定位生效
      }
      // 已上传图片预览图适配
      .el-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      // 1. 删除按钮样式（基准）
      .el-upload-list__item-delete {
        font-size: 16px !important; // 按钮大小
        top: 5px !important;        // 垂直位置
        right: 5px !important;      // 水平位置
        width: 20px !important;     // 点击区域大小
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景（可选，和预览按钮统一）
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
      }

      // 2. 预览按钮样式（和删除按钮完全统一）
      .el-upload-list__item-preview {
        font-size: 16px !important; // 和删除按钮同大小
        top: 5px !important;        // 和删除按钮同垂直位置
        right: 30px !important;     // 位于删除按钮左侧，间距合理
        width: 20px !important;     // 点击区域和删除按钮一致
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景，和删除按钮统一
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
        // 预览图标居中
        .el-icon-zoom-in {
          font-size: 14px !important; // 图标略小于按钮，视觉更协调
          line-height: 20px !important;
        }
      }

      // 鼠标悬浮效果（可选，增强交互）
      .el-upload-list__item:hover .el-upload-list__item-delete,
      .el-upload-list__item:hover .el-upload-list__item-preview {
        background: rgba(0,0,0,0.7);
      }
    }

    // 预览弹框空状态样式
    .preview-empty {
      text-align: center;
      padding: 20px;
      color: #999;
      font-size: 14px;
    }



    /* ------------------------- 6. 其他样式 --------------------------- */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }
    .reason-item {
      height: auto !important; // 修复原因说明项固定高度问题
      padding-bottom: 10px;
    }
    .reason-textarea {
      margin-top: 10px;
      width: 100%;
    }
    .upload-tip {
      font-size: 10px;
      color: #999;
      margin-top: 5px;
    }
    .s-footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }

  // ===================== PC端适配（≥1200px） =====================
  @media screen and (min-width: 1200px) {
    max-width: 1200px; // PC端最大宽度
    margin: 0 auto; // 居中
    padding: 0 20px;
    /* -------------------------- 1. 复选框样式 -------------------------- */
    .el-checkbox {
      font-size: 14px;
    }
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 2px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      width: 8px;
      height: 14px;
      top: -5px;
    }
    .el-checkbox__label {
      margin: 0 auto;
      font-size: 10px;
    }

    /* -------------------------- 2. 下拉选择框（核心修复） -------------------------- */
    .addr-select {
      width: 100%;
      // 输入框基础样式（保留原有）
      .el-input__suffix {
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
      .el-input__icon {
        width: 16px !important;
        height: 16px !important;
        font-size: 14px !important;
        line-height: 16px !important;
        vertical-align: middle;
        margin-left: 5px;
      }
      .el-input__inner {
        padding-right: 25px !important;
        font-size: 16px !important;
        height: 50px !important;
        line-height: 50px !important;
        border: none;
        border-radius: 4px;
        background: #f9f9f9;
        padding-left: 10px;
      }

      // 1. 下拉面板整体样式
      .el-select-dropdown {
        width: 100% !important; // 适配容器宽度
        margin-top: 5px !important;
        border: none !important;
        border-radius: 6px !important;
        box-shadow: 0 2px 12px rgba(0,0,0,0.1) !important; // 柔和阴影
        background: #fff !important;
        padding: 5px 0 !important; // 上下内边距
      }

      // 2. 下拉选项样式
      .el-select-dropdown__item {
        height: 20px !important; // 适配移动端点击区域
        line-height: 20px !important;
        font-size: 15px !important; // 字体大小适配
        padding: 0 15px !important; // 左右内边距
        color: #333 !important;
        transition: all 0.2s ease; // 过渡动画
        // 选项hover样式
        &:hover {
          background: #f8e8d1 !important; // 主色调浅背景
          color: #0f0f0f !important;
        }
        // 选中项样式
        &.selected {
          color: #0f0f0f !important;
          font-weight: 500;
          background: #f6c27a !important; // 主色调背景
        }
        // 禁用项样式
        &.is-disabled {
          color: #ccc !important;
          background: #fafafa !important;
        }
      }

      // 3. 搜索框样式（filterable）
      .el-select-dropdown__empty,
      .el-select__input {
        font-size: 15px !important;
        padding: 0 10px !important;
        height: 45px !important;
        line-height: 45px !important;
      }

      // 4. 下拉面板空状态
      .el-select-dropdown__empty {
        text-align: center;
        padding: 15px;
        color: #999;
        font-size: 14px;
      }

      // 5. 禁用状态下的输入框样式
      &.is-disabled {
        .el-input__inner {
          background: #f5f5f5 !important;
          color: #999 !important;
          cursor: not-allowed;
        }
      }
    }

    /* ------------------------ 3. 图片上传 ---------------------------- */
    .el-upload--picture-card {
      height: 50px;
      line-height: 50px;
    }

    /* ------------------------- 4. 底部按钮 --------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 20px 0;
    }
    .el-button--primary {
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }
    .el-button--default {
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* ------------------------- 5. 文本框 --------------------------- */
    .form-inline {
      padding: 5px 0;
    }
    .el-form-item {
      background: #ffffff;
      height: auto; // 修复原固定高度导致的内容溢出
      padding: 0 10px;
      margin-bottom: 5px; // 增加表单项间距
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content {
      line-height: 50px;
      padding-left: 30px;
      .el-checkbox {
        line-height: 30px;
      }
    }
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;
      height: 50px !important;
      line-height: 50px !important;
      border: none;
    }
    .el-textarea {
      vertical-align: top;
    }


    /* -------------------------- 仅增加 Label 宽度 -------------------------- */
    .el-form {
      // 覆盖Element默认Label宽度，与模板中 label-width 保持一致
      --el-form-label-width: 90px !important;
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important;
      text-align: left !important;
      line-height: 50px;
      white-space: nowrap !important; // 保留强制不换行（配合宽度增加）
      flex: 0 0 100px !important; // 固定宽度与 label-width 一致
      max-width: 90px !important; // 最大宽度同步
    }

    /* 核心修改：单选框样式适配 */
    .reason-radio-group {
      display: flex;
      flex-wrap: wrap; // 选项过多时自动换行
      gap: 10px 15px; // 选项间距（上下/左右）
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .reason-radio {
      font-size: 14px !important;
      .el-radio__inner {
        width: 14px;
        height: 14px; // 单选按钮大小
      }
      .el-radio__label {
        font-size: 12px !important;
        margin-left: 5px; // 按钮与文字间距
      }
    }

    /* -------------------------- 核心修改：统一预览/删除按钮样式 -------------------------- */
    // 上传卡片/缩略图基础样式
    .avatar-uploader {
      .el-upload--picture-card {
        width: 100px !important;
        height: 100px !important;
        line-height: 100px !important;
        font-size: 20px !important;
      }
    }
    .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        position: relative; // 确保子元素绝对定位生效
      }
      // 已上传图片预览图适配
      .el-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      // 1. 删除按钮样式（基准）
      .el-upload-list__item-delete {
        font-size: 16px !important; // 按钮大小
        top: 5px !important;        // 垂直位置
        right: 5px !important;      // 水平位置
        width: 20px !important;     // 点击区域大小
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景（可选，和预览按钮统一）
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
      }

      // 2. 预览按钮样式（和删除按钮完全统一）
      .el-upload-list__item-preview {
        font-size: 16px !important; // 和删除按钮同大小
        top: 5px !important;        // 和删除按钮同垂直位置
        right: 30px !important;     // 位于删除按钮左侧，间距合理
        width: 20px !important;     // 点击区域和删除按钮一致
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景，和删除按钮统一
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
        // 预览图标居中
        .el-icon-zoom-in {
          font-size: 14px !important; // 图标略小于按钮，视觉更协调
          line-height: 20px !important;
        }
      }

      // 鼠标悬浮效果（可选，增强交互）
      .el-upload-list__item:hover .el-upload-list__item-delete,
      .el-upload-list__item:hover .el-upload-list__item-preview {
        background: rgba(0,0,0,0.7);
      }
    }

    // 预览弹框空状态样式
    .preview-empty {
      text-align: center;
      padding: 20px;
      color: #999;
      font-size: 14px;
    }



    /* ------------------------- 6. 其他样式 --------------------------- */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }
    .reason-item {
      height: auto !important; // 修复原因说明项固定高度问题
      padding-bottom: 10px;
    }
    .reason-textarea {
      margin-top: 10px;
      width: 100%;
    }
    .upload-tip {
      font-size: 10px;
      color: #999;
      margin-top: 5px;
    }
    .s-footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }
}
</style>